export default "__VITE_ASSET__bc65fe0e__"